import { AccountState } from './types'

const initialState: AccountState = {
  isLoading: false,
  error: false,
  summaries: undefined
}

export default initialState
